export default __webpack_public_path__ + "static/media/photo--lg--hockey6.cabafbd8.jpg";